<template>
  <div class="rtb-stats__widget">
  <SmartTableWidget
    :widget="{
          tableTitle: $t('RTT_ERRORS'),
          locale: $options.i18n
      }"
    :column-defs="columns"
    :row-data="errorData || []"
    :enable-date-range-filter="false"
    :enable-export="true"
    :enable-search="true"
    :searchKeys="['rttName', 'rttId']"
    :search-placeholder="$t('INPUT_SEARCH_RTT_PLACEHOLDER')"
    :export-title="'Ring Tree Target Dispositions ' + dateRange[0] + '--' + dateRange[1]"
    :enable-popover-on-click="true"
    :isLoadingTableData="isLoading"
    :isLoadingPopoverData="isSearching"
    :popoverData="lastErrors"
    @onClickCell="handleOnClickCell"
  >
   <template #table>
      <LoadingStatusDisplay
        v-if="isLoading"
      />
      <div
        v-else-if="!errorData"
        class="empty-records"
      >
        {{ $t('RTT_DASHBOARD_PANE_EMPTY') }}
      </div>
    </template>
  </SmartTableWidget>
  </div>
</template>
<script>
import LoadingStatusDisplay from '@/core/components/Loader/LoadingStatusDisplay.vue';
import SmartTableWidget from '@/core/components/SmartTable/SmartTableWidget.vue';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { columnSettings } from '../../columnSettings'
import { mapActions, mapGetters } from 'vuex';
import { STATUS_PENDING, STATUS_ERROR } from '@/store/helpers';
export default {
  name: 'RingTreeTargetErrors',
  components: { SmartTableWidget, LoadingStatusDisplay },
  props: {
    errorData: {
      type: Array,
      default: []
    },
    dateRange: {
      type: Array,
      default: []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: columnSettings.errorData,
      pingDates: 'Today',
      lastErrors: {},
    }
  },
  computed: {
    ...mapGetters('ringTreeTargets', ['getRttLastErrorsStatus']),
    isSearching() {
      return this.getRttLastErrorsStatus.status === STATUS_PENDING;
    },
  },
  methods: {
    ...mapActions('ringTreeTargets', ['getRttErrorsLastCalls']),
    async handleOnClickCell(cellProps) {
      this.lastErrors = { title: this.$i18n.t('RTT_LAST_CALLS')}
      const response = await this.getRttErrorsLastCalls(cellProps);
      if (this.getRttLastErrorsStatus.status === STATUS_ERROR) {
        this.lastErrors = {
          ...this.lastErrors,
          errorMessage: this.getRttLastErrorsStatus.error,
          data: []
        }
        return;
      }

      this.lastErrors = {
        ...this.lastErrors,
        errorMessage: '',
        data: response,
      }

    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
}

</script>